import React, { useEffect, useState } from "react";
import { http } from "@/context/AuthContext";
import { Loader2, Receipt, Download } from "lucide-react";

export default function PortalInvoices() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    http.get("/portal/invoices").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);
  return (
    <div data-testid="portal-invoices">
      <h1 className="text-4xl">Invoices</h1>
      <p className="mt-2 text-navy/65">View and pay outstanding invoices, or review your payment history.</p>
      <div className="mt-8">
        {loading ? (
          <div className="flex items-center gap-2 text-navy/60"><Loader2 className="w-4 h-4 animate-spin" /> Loading…</div>
        ) : items.length === 0 ? (
          <div className="card p-10 text-center">
            <Receipt className="w-10 h-10 text-gold mx-auto" />
            <h3 className="mt-3 text-2xl">No invoices yet.</h3>
            <p className="mt-2 text-navy/65">When the team issues an invoice, it'll appear here.</p>
          </div>
        ) : (
          <ul className="card divide-y divide-navy/5">
            {items.map((inv, i) => (
              <li key={i} className="p-5 flex items-center justify-between" data-testid={`invoice-${i}`}>
                <div>
                  <div className="text-navy font-medium">{inv.title || inv.service_name}</div>
                  <div className="text-xs text-navy/55">Issued {inv.created_at?.slice(0, 10)} · ${(inv.amount_cents || 0) / 100}</div>
                </div>
                <div className="flex items-center gap-3">
                  <span className={`text-xs uppercase tracking-widest ${inv.status === "paid" ? "text-teal" : "text-gold"}`}>{inv.status}</span>
                  {inv.url && (
                    <a href={inv.url} target="_blank" rel="noreferrer" className="text-navy/60 hover:text-navy" aria-label="Download">
                      <Download className="w-4 h-4" />
                    </a>
                  )}
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
